const c2aPopup = {
  el: null,

  init() {
    this.el = $("#c2a-popup");

    if (!this.el.length) {
      return;
    }

    let userSeen = sessionStorage.getItem("c2aPopupSeen");
    if (userSeen) {
      return;
    }

    setTimeout(() => {
      c2aPopup.show();
    }, 5000);

    this.events();
  },

  show() {
    $("html").addClass("no-scroll");
    this.el.addClass("open");
  },

  close(disable = true) {
    $("html").removeClass("no-scroll");
    this.el.removeClass("open");

    if (disable) {
      sessionStorage.setItem("c2aPopupSeen", true);
    }
  },

  events() {
    this.el.find(".popup__bg").on("click", () => {
      c2aPopup.close(false);
    });

    this.el.find(".popup__close").on("click", () => {
      c2aPopup.close();
    });

    this.el.find(".c2a-slim__btn").on("click", (e) => {
      e.preventDefault();

      sessionStorage.setItem("c2aPopupSeen", true);

      setTimeout(() => {
        window.location = $(e.currentTarget).attr("href");
      });
    });
  },
};

export default c2aPopup;
